import { render, staticRenderFns } from "./RuleOverview.vue?vue&type=template&id=04d94105&scoped=true"
import script from "./RuleOverview.vue?vue&type=script&lang=js"
export * from "./RuleOverview.vue?vue&type=script&lang=js"
import style0 from "./RuleOverview.vue?vue&type=style&index=0&id=04d94105&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d94105",
  null
  
)

export default component.exports